import React from 'react';
import { Grid } from '@mui/material';
import CardMeals from './CardMeals';
import SearchMeals from './SearchMeals';

const MenuList = (props) => {
  
  const { updateQuantity, addMeal, orderItems, deleteMeal } = props;

  return (
    <Grid container spacing={2} >
        <Grid marginY={2} item xs={12} sm={12} md={6} lg={6} >
            <CardMeals {...{updateQuantity: updateQuantity, orderItems: orderItems, deleteMeal: deleteMeal}} />
        </Grid>
        <Grid marginY={2} item xs={12} sm={12} md={6} lg={6} >
            <SearchMeals {...{addMeal: addMeal}} />
        </Grid>
    </Grid>
  )
}

export default MenuList